import React from 'react';
import { Box, Container, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { AppRoutes } from '../../constants/routes';

const LegalFooter = () => (
  <Box
    component="footer"
    sx={{
      backgroundColor: '#0a0a0a',
      borderTop: '1px solid #333',
      py: 3,
      mt: 'auto'
    }}
  >
    <Container maxWidth="lg">
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Link component={RouterLink} to={AppRoutes.TermsOfService} color="inherit" underline="hover">
          Terms of Service
        </Link>
        <Link component={RouterLink} to={AppRoutes.PrivacyPolicy} color="inherit" underline="hover">
          Privacy Policy
        </Link>
        <Link component={RouterLink} to={AppRoutes.DmcaPolicy} color="inherit" underline="hover">
          DMCA
        </Link>
        <Link component={RouterLink} to={AppRoutes.Support} color="inherit" underline="hover">
          Support
        </Link>
        <Typography variant="caption" sx={{ color: '#666', width: '100%', textAlign: 'center' }}>
          © {new Date().getFullYear()} Tuneswell. Questions: peter@tuneswell.com
        </Typography>
      </Box>
    </Container>
  </Box>
);

export default LegalFooter;
